import React from "react";
import { Lock, Sparkles, Check } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { hasFeature, requiredTierLabel, FEATURE_NAMES, TIER_LABEL, tierOf } from "../../lib/entitlements";
import { isNativeApp } from "../../lib/platform";
import { PageWrap } from "./ui";

const PERKS = {
  coaches: ["Chat with your AI coach", "Personalised, judgement-free guidance", "Premium Elite: all 5 coaches + unlimited"],
  wellness: ["Habits, goals & private journal", "Build streaks that stick"],
  cycle: ["Cycle-synced training & energy", "Daily Edge check-ins"],
  passport: ["Stamp every country you visit", "3D globe of your journey"],
  wearables: ["Auto-sync Strava activities", "Your workouts flow into the feed"],
  leaderboard: ["Global & country rankings", "Compete with the WYVN community"],
  challenges: ["Join movement & hydration challenges", "Earn points and badges"],
  community: ["Connect with members worldwide", "Tribes & messaging"],
  family: ["Add family members", "Shared plans & activity"],
};

export function UpgradeGate({ feature, onNavigate, children }) {
  const { member } = useAuth();
  if (hasFeature(member, feature)) return children;
  const need = requiredTierLabel(feature);
  const name = FEATURE_NAMES[feature] || "This feature";
  return (
    <PageWrap>
      <div className="mx-auto max-w-lg" data-testid={`upgrade-gate-${feature}`}>
        <div className="glass overflow-hidden rounded-[2rem] p-8 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-brand/15 text-brand"><Lock size={26} /></div>
          <div className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-semibold text-gold"><Sparkles size={12} /> {need} plan</div>
          <h2 className="mt-3 font-display text-2xl font-semibold text-mist">{name}</h2>
          <p className="mt-1 text-sm text-mist-muted">You're on the <span className="font-medium text-mist">{TIER_LABEL[tierOf(member)]}</span> plan. Upgrade to unlock {name.toLowerCase()}.</p>
          <div className="mt-6 space-y-2 text-left">
            {(PERKS[feature] || []).map((p) => (
              <div key={p} className="flex items-center gap-2.5 text-sm text-mist"><Check size={16} className="shrink-0 text-sage" /> {p}</div>
            ))}
          </div>
          {isNativeApp() ? (
            <p className="mt-7 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-mist-muted" data-testid="upgrade-native-note">
              This is part of the <span className="font-medium text-mist">{need}</span> membership. If your account includes it, it unlocks here automatically.
            </p>
          ) : (
            <button onClick={() => onNavigate("subscription")} data-testid="upgrade-cta-btn" className="btn-primary mt-7 w-full">Upgrade to {need}</button>
          )}
        </div>
      </div>
    </PageWrap>
  );
}
